import { render, staticRenderFns } from "./AyudaPartes.vue?vue&type=template&id=61d1741f&scoped=true"
import script from "./AyudaPartes.vue?vue&type=script&lang=js"
export * from "./AyudaPartes.vue?vue&type=script&lang=js"
import style0 from "./AyudaPartes.vue?vue&type=style&index=0&id=61d1741f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d1741f",
  null
  
)

export default component.exports